import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import { isEpisodePlayerMeta, presentTitle } from '@/shared/lib/movie';
import { usePlayerData } from '@/scenarios/player/hooks/usePlayerData';

import { PlayerHead } from '../../../feature-player/ui/player-head/component';
import { MoviePlayerMeta } from '../../../movie-player/ui/MoviePlayerMeta';
import { getMovieMetaLogo } from '../../../movie-player/utils/get-movie-meta-logo';
import { withControlErrorBoundary } from '../../../feature-player/ui/control-error-boundary/hoc';
import { useEditorAnnotationVisible } from '../../../film-player/hooks/useEditorAnnotationVisible';
import { getMetaSubTitle } from '../../utils/getMetaSubtitle';

interface EpisodePlayerMetaContainerProps {
    contentId: string;
    className?: string;
    isControlsVisible: boolean;
}

const EpisodePlayerMetaContainer: FC<EpisodePlayerMetaContainerProps> = ({
    contentId,
    className,
    isControlsVisible,
}) => {
    const intl = useIntl();

    const { playerMeta } = usePlayerData(contentId);
    const isEditorAnnotationVisible = useEditorAnnotationVisible(isControlsVisible);

    if (!isEpisodePlayerMeta(playerMeta)) {
        return null;
    }

    const { tvSeriesMeta } = playerMeta;
    const subtitle = getMetaSubTitle(intl, playerMeta);
    const logo = getMovieMetaLogo(tvSeriesMeta?.horizontalLogo ?? null);
    const metaTitle = presentTitle(tvSeriesMeta?.title);
    const editorAnnotation = isEditorAnnotationVisible
        ? tvSeriesMeta?.editorAnnotation || undefined
        : undefined;

    return (
        <>
            <PlayerHead playerMeta={playerMeta} />
            {isControlsVisible && (
                <MoviePlayerMeta
                    title={metaTitle || ''}
                    subtitle={subtitle}
                    logoUrl={logo?.logoUrl}
                    logoWidth={logo?.width}
                    logoHeight={logo?.height}
                    className={className}
                    editorAnnotation={editorAnnotation}
                />
            )}
        </>
    );
};

export const EpisodePlayerMetaControl = withControlErrorBoundary(EpisodePlayerMetaContainer);
